import { SelectField as GammaSelectField } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

type SelectFieldProps = React.ComponentProps<typeof GammaSelectField>

type Props = Omit<SelectFieldProps, 'selectValue' | 'missingLabel'> & {
  missingLabel?: string
}

const SelectField: React.FC<Props> = ({ missingLabel, ...props }) => (
  <GammaSelectField
    {...props}
    missingLabel={missingLabel ?? i18n.t('common.missing_field')}
    selectValue={i18n.t('common.select')}
  />
)

export default SelectField
